module.exports = __webpack_public_path__ + "img/menu-24px.55f68494.svg";